import { Link } from 'react-router-dom';
import useScrollAnimation from '@/hooks/useScrollAnimation';

export default function StorySection() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.08 });

  return (
    <section
      ref={ref}
      className="relative min-h-[100svh] flex flex-col items-center justify-center bg-background-100 overflow-hidden py-20 md:py-0"
    >
      <div className="relative z-10 flex flex-col items-center text-center px-6 md:px-10 w-full">
        <div
          className={`max-w-[720px] w-full transition-all duration-700 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-block text-xs text-foreground-400 uppercase tracking-widest mb-4">
            品牌介紹
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
            沐燁文化 Moya 委託崧博出版經銷，官方網站由崧博出版製作。
          </h2>
          <div className="space-y-3 text-left mb-8">
            <div className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 shrink-0">
                <i className="ri-building-line text-sm"></i>
              </span>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                沐燁文化 Moya 委託崧博出版經銷，官方網站由崧博出版製作。本網站提供品牌介紹、正式出版書籍及崧博出版書籍資料庫查詢入口。
              </p>
            </div>
            <div className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 shrink-0">
                <i className="ri-database-2-line text-sm"></i>
              </span>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                正式出版書籍的書名、作者、ISBN、出版日期及完整書目資訊，可前往崧博出版書籍資料庫查詢。
              </p>
            </div>
            <div className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 shrink-0">
                <i className="ri-mail-line text-sm"></i>
              </span>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                品牌經銷與合作方案詳情請直接聯繫洽詢。
              </p>
            </div>
          </div>

          <div className="mt-8 mb-8">
            <div className="relative aspect-[4/3] rounded-xl overflow-hidden bg-primary-50 max-w-[480px] mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20publishing%20studio%20with%20open%20books%20and%20natural%20light%2C%20warm%20cream%20and%20navy%20blue%20color%20palette%2C%20clean%20editorial%20aesthetic%2C%20soft%20natural%20lighting%2C%20professional%20knowledge%20publishing%20atmosphere&width=760&height=570&seq=brand-story-01&orientation=landscape"
                alt="沐燁文化 Moya"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <Link
            to="/about"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer group"
          >
            了解沐燁文化
            <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform duration-200">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}